import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ permission = "view", children }) => {
  const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
  const location = useLocation();
  
  // Check if user is authenticated
  if (!userDetails || !userDetails.user_sidebar) {
    // Redirect to login if not authenticated
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  // Super admin bypass - always has access
  if (userDetails?.my_role?.slug === "super-admin") {
    return children;
  }
  
  // Extract the current path to match with sidebar slugs
  const currentPath = location.pathname.split('/').filter(Boolean)[0] || location.pathname; 
  
  // Find if user has permission for this path
  const hasAccess = userDetails.user_sidebar.some(sidebar => {
    // Normalize paths for comparison
    const sidebarSlug = sidebar.slug.startsWith('/') ? sidebar.slug.substring(1) : sidebar.slug;
    const pathToCheck = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;
    
    // Check if the current path matches the sidebar slug
    const slugMatches = sidebarSlug === pathToCheck || sidebarSlug === currentPath || pathToCheck === '';
    
    // For "any" permission, check if user has any permissions for this path
    if (permission === "any" && slugMatches && sidebar.permissions && sidebar.permissions.length > 0) {
      return true;
    }
    
    // For dashboard special case - allow if user has either view or export permission
    if (pathToCheck === 'dashboard' && slugMatches && sidebar.permissions) {
      return sidebar.permissions.some(perm => perm.slug === "view" || perm.slug === "export");
    }
    
    // For regular permissions, check if user has the required permission for this sidebar item
    return slugMatches && 
      sidebar.permissions && 
      sidebar.permissions.some(perm => perm.slug === permission);
  });
  
  return hasAccess ? children : <Navigate to="/no-access" replace />;
};

export default ProtectedRoute;
